module.exports = __webpack_public_path__ + "img/poster-image-01.605e1cf8.jpg";